import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/index/Home.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
        {
            path: '/',
            name: 'root',
            component: () => import('@/views/index/Index'),
        },
        {
            path: '/404',
            name: '404',
            component: () => import('@/views/404'),
        },
        {
            path: '/home',
            name: 'home',
            component: Home,
        },
        {
            path: '/index',
            name: 'index',
            component: () => import('@/views/index/Index'),
        },
        {
            path: '/about',
            name: 'about',
            component: () => import('@/views/about/Index'),
        },
        {
            path: '/corp',
            name: 'corp',
            component: () => import('@/views/corp/Index'),
        },
        {
            path: '/jd',
            name: 'jd',
            component: () => import('@/views/about/JD'),
        },
        {
            path: '/business/:id',
            name: 'business',
            component: () => import('@/views/business/Index'),
        },
        {
            path: '/business/list/china',
            name: 'domestic',
            component: () => import('@/views/business/Index'),
            props: { documentUrl: 'domestic' },
        },
        {
            path: '/business/list/overseas',
            name: 'overseas',
            component: () => import('@/views/business/Index'),
            props: { documentUrl: 'overseas' },
        },
        {
            path: '/business/detail/:id',
            name: 'businessDetail',
            component: () => import('@/views/business/Detail'),
        },
        {
            path: '/train/:id',
            name: 'train',
            component: () => import('@/views/train/Index'),
        },
        {
            path: '/service/:id',
            name: 'service',
            component: () => import('@/views/service/Index'),
        },
        {
            path: '/buy/:id',
            name: 'buy',
            component: () => import('@/views/service/Buy'),
        },
        {
            path: '/pay/:id',
            name: 'pay',
            component: () => import('@/views/service/Pay'),
        },
        {
            path: '/news/list',
            name: 'newsList',
            component: () => import('@/views/detail/NewsPage'),
        },
        {
            path: '/news/detail/:id',
            name: 'newsDetail',
            component: () => import('@/views/detail/CustomDetailPage'),
        },
        {
            path: '/nav/:id',
            name: 'customNav',
            component: () => import('@/views/detail/CustomNavPage'),
            props: route => ({ navId: route.params.id }),
        },
        {
            path: '/press/detail/:id',
            name: 'pressDetail',
            component: () => import('@/views/corp/PressDetail'),
        },
        {
            path: '/train/detail/:id',
            name: 'trainDetail',
            component: () => import('@/views/train/Detail'),
        },
        {
            path: '/preview/home',
            name: 'previewHome',
            component: () => import('@/views/preview/Home'),
        },
        {
            path: '/preview/business',
            name: 'previewBusiness',
            component: () => import('@/views/preview/Business'),
        },
        {
            path: '/preview/service',
            name: 'previewService',
            component: () => import('@/views/preview/Service'),
        },
        {
            path: '/preview/about/culture',
            name: 'previewCulture',
            component: () => import('@/views/preview/Culture'),
        },
        {
            path: '/preview/about/intro',
            name: 'previewIntro',
            component: () => import('@/views/preview/Intro'),
        },
        {
            path: '/preview/news',
            name: 'previewNews',
            component: () => import('@/views/preview/News'),
        },
        {
            path: '/preview/train',
            name: 'previewTrain',
            component: () => import('@/views/preview/Train'),
        },
        {
            path: '/preview/press',
            name: 'previewPress',
            component: () => import('@/views/preview/Press'),
        },
        {
            path: '/preview/footer',
            name: 'previewFoot',
            component: () => import('@/views/preview/Footer'),
        },
    ],
});
